module.exports = __webpack_public_path__ + "img/2.4f7cf007.jpg";